import React from "react";
import { useLang } from "@/i18n/LanguageContext";

export const PageShell = ({ title, subtitle, children, testId }) => {
  return (
    <main className="relative max-w-6xl mx-auto px-6 lg:px-10 pt-16 pb-10" data-testid={testId}>
      <p className="label-overline mb-4">FACOW360</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-amber-glow leading-tight mb-6 tracking-tight">
        {title}
      </h1>
      {subtitle && <p className="text-base lg:text-lg text-slate-300 max-w-3xl leading-relaxed mb-12">{subtitle}</p>}
      {children}
    </main>
  );
};

export const PillarFeatures = ({ items }) => (
  <div className="grid md:grid-cols-2 gap-6">
    {items.map((it, idx) => (
      <div key={idx} className="glow-border rounded-2xl p-6 glass" data-testid={`feature-${idx}`}>
        <p className="label-overline mb-3">{`0${idx + 1}`}</p>
        <h3 className="font-display text-xl text-cyan-glow mb-3">{it.title}</h3>
        <p className="text-sm text-slate-300 leading-relaxed">{it.text}</p>
      </div>
    ))}
  </div>
);

export const DisclaimerBanner = () => {
  const { t } = useLang();
  return (
    <div className="mt-16 border border-[#D4AF37]/30 rounded-xl bg-[#D4AF37]/5 px-5 py-4 text-xs text-slate-300" data-testid="disclaimer-banner">
      {t("disclaimer")}
    </div>
  );
};

export const PillarSection = ({ heading, children, testId, id }) => (
  <section className="mt-12 first:mt-0 scroll-mt-28" id={id} data-testid={testId}>
    <h2 className="font-display text-2xl md:text-3xl text-cyan-glow mb-5 leading-tight tracking-tight">
      {heading}
    </h2>
    <div className="space-y-4 text-slate-300 leading-relaxed text-base max-w-4xl">
      {children}
    </div>
  </section>
);

export const TransparencyNote = ({ children }) => {
  const { locale } = useLang();
  const isFr = locale === "fr";
  return (
    <aside
      className="mt-12 rounded-2xl border-l-4 border-l-[#D4AF37] border border-[#D4AF37]/30 bg-gradient-to-br from-[#D4AF37]/10 via-[#0A1128]/40 to-transparent px-6 py-5 backdrop-blur-sm"
      data-testid="transparency-note"
      role="note"
      aria-label={isFr ? "Note de transparence FACOW360" : "FACOW360 transparency note"}
    >
      <p className="label-overline mb-2 text-[#D4AF37]">
        {isFr ? "Note de transparence FACOW360" : "FACOW360 transparency note"}
      </p>
      <p className="text-sm text-slate-200 leading-relaxed italic">{children}</p>
    </aside>
  );
};
